import React from 'react'
import { Box, Divider, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"


export default function conditionNameColumn() {

	const iconMap = {
		"More expensive": "chart-line-up",
		"Cheaper": "chart-line-down",
		"Cheaper/More expensive": "chart-line-up-down",
		"$": "money-bills",
		"%": "percent"
	}
	const colorMap = {
		"More expensive": "success.main",
		"Cheaper": "error.main",
		"Cheaper/More expensive": "warning.main",
		"$": "success.dark",
		"%": "black"
	}

	return {
		name: 'conditionName',
		label: 'Condition',
		options: {
			filter: false,
			customBodyRowRenderLite:
				(value, { comparatorName, comparatorValue, comparatorUnitName }) => <Box sx={{
					display: "flex",
					alignItems: 'center',
					justifyContent: "center",
					flexDirection: "column"
				}}>
					<Typography sx={{ fontWeight: "bold" }}>{value}</Typography>
					<Divider sx={{ my: 1, width: "80%", borderBottom: "2px solid" }}/>
					<Box sx={{ display: "flex", alignItems: 'center', justifyContent: "center" }}>
						<Typography sx={{ fontWeight: "bold" }}>{comparatorValue}</Typography>
						<IconSeeker icon={iconMap[comparatorUnitName]}
									sx={{ mx: .7, fontSize: 14, color: colorMap[comparatorUnitName] }}/>
						<IconSeeker
							tooltip={comparatorName}
							icon={iconMap[comparatorName]}
							sx={{ fontSize: 14, color: colorMap[comparatorName] }}
						/>
					</Box>
				</Box>
		}
	}
}